// This is a dummy file, to make the project work without the AI extension.
import { Extension } from '@tiptap/core'

export const AiWriter = Extension.create({
  name: 'aiWriterFree',
})
